import React, { Component } from 'react';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

const statisticsEnum = {
    // 规模
    MONTH_GROUP: '每月入组数/每月累计入组数', // 入组情况
    MONTH_IN_GROUP: '每月在组数', // 在组情况
    MONTH_CRC_FTE: '每月CRC消耗FTE/每月累计CRC消耗FTE', // CRC消耗FTE情况
    MONTH_PROJECT_NUM: '每月进行中项目数/每月结束项目数/每月所有项目数', // 项目数量情况
    MONTH_VISIT_AMOUNT: '每月完成访视数/每月累计完成访视数', // 完成访视情况
    MONTH_STANDARD_VISIT_AMOUNT: '每月完成标准访视数/每月累计完成标准访视数', // 每月完成标准访视情况
    MONTH_NEW_SITE: '每月启动中心数/每月累计启动中心数', // 中心启动情况
    //  效率
    MONTH_UNITS_FTE_GROUP: '每月单位FTE入组数', // 每月单位FTE入组数
    MONTH_UNITS_FTE_VISIT: '每月单位FTE访视数', // 每月单位FTE访视数
    MONTH_UNITS_FTE_STANDARD_VISIT: '每月单位FTE标准访视数', // 每月单位FTE标准访视数
    MONTH_PER_RANDOM_AMOUNT: '每月人均入组数',
    MONTH_PER_VISIT_AMOUNT: '每月人均访视数',
    MONTH_PER_STANDARD_VISIT_AMOUNT: '每月人均确认标准访视数',
    // 运营监控
    MONITOR_SITE_START_GLOBAL: '每月平均启动时长',   // 平均启动时长
    REQUIREMENT_SATISFIED_GLOBAL: '每月需求满足量/每月需求总量/每月需求满足率', // 需求满足率
    REQUIREMENT_FTE_GLOBAL: '当月已处理需求的FTE/当月待处理需求的FTE', // 需求FTE情况
    MONTH_MAJOR_EVENT: '每月重大事件发生数/累计重大事件数', // 每月重大事件发生数
    MONTH_MAJOR_EVENT_RATE: '当年累计重大事件数/当年累计完成访视数/当年重大事件发生率', // 每月重大事件发生率
    // 进度差异
    PLAN_RANDOM_AMOUNT: '每月计划入组数/每月实际入组数',   // 计划/实际入组情况
    PLAN_VISIT_AMOUNT: '每月计划访视数/每月实际访视数', // 计划/实际访视情况
    PLAN_SITE_START: '每月计划启动数/每月实际启动数', // 计划/实际启动情况
    PLAN_FTE: '每月CRC计划FTE/每月CRC消耗FTE', // 计划/实际FTE情况
    INV_PLAN_FTE_PROGRESS_DIFF_GRAPH: '每月项目计划FTE/每月项目消耗FTE', // 项目计划/实际项目FTE情况
};

class ProjectTable extends Component {
    state = {
        data: {},
        params: {...this.props.params},
        pagination: {
            current: 1,
            pageSize: 10,
        },
        loading: false,
    }

    shouldComponentUpdate(nextProps) {
        if (
            nextProps.data !== this.props.data || 
            nextProps.params.displayType == this.props.params.displayType
        ) {
            return true;
        }
        return false;
    }

    componentDidMount() {
        const { data, params } = this.props;
        const { analysisDimension } = params;
        // if (analysisDimension === 'HOSPITAL' || analysisDimension === 'DEPARTMENT') {
        //     this.setState({ params }, () => {
        //         this.loadData();
        //     });
        // } else {
            this.setState({
                data,
                params,
            });
        // }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.params !== this.props.params) {
            const { data, params } = nextProps;  
                this.setState({
                    params,
                })
       }
    }

    loadData = (tableChange) => {
        const { params, pagination } = this.state;
        const { year, moduleType, analysisDimension, investigationMedicineType = [] } = this.props.params;
        const { current, pageSize } = pagination;
        const twoRow = moduleType === 'MONTH_CRC_FTE' || moduleType === 'MONTH_GROUP' || moduleType === 'MONTH_VISIT_AMOUNT' || moduleType === 'MONTH_STANDARD_VISIT_AMOUNT' || moduleType === 'MONTH_MAJOR_EVENT' || moduleType === 'PLAN_RANDOM_AMOUNT' || moduleType === 'PLAN_VISIT_AMOUNT' || moduleType === 'PLAN_SITE_START' || moduleType === 'PLAN_FTE' || moduleType === 'INV_PLAN_FTE_PROGRESS_DIFF_GRAPH'
        ||(moduleType ==="REQUIREMENT_FTE_GLOBAL"&&analysisDimension==="AREA")
        ||(moduleType ==="REQUIREMENT_FTE_GLOBAL"&&analysisDimension==="PROJECT_AREA")
        || (moduleType ==="REQUIREMENT_FTE_GLOBAL"&&analysisDimension==="DISEASE")
        || (moduleType ==="REQUIREMENT_FTE_GLOBAL"&&analysisDimension==="PROJECT")
        || (moduleType ==="REQUIREMENT_FTE_GLOBAL"&&analysisDimension==="DEPARTMENT");// 跨2行在此设置
        const threeRow = (moduleType === 'MONTH_PROJECT_NUM' && analysisDimension!=="GLOBAL") || moduleType === 'REQUIREMENT_SATISFIED_GLOBAL' || moduleType === 'MONTH_MAJOR_EVENT_RATE';// 跨3行在此设置

        this.setState({ loading: true });
        let limit = pageSize;
        if (twoRow) { // 跨2行在此设置
            limit = 5;
        } else if (threeRow) {  // 跨3行在此设置
            limit = 3;
        }else{
            limit = 10;
        }
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryStatisticReportData,
            data: {
                ...params,
                investigationMedicineType: investigationMedicineType[0],
                secondResearchProductType: investigationMedicineType[1],
                offset: current,
                statisticDate: `${year}-01`,
                statisticEndDate: `${year}-12`,
                limit,
            },
            dataType: 'json',
            doneResult: res => {
                const { tableDatas, totalCount = 0 } = res;
                if (analysisDimension === 'GLOBAL') {
                    pagination.total = tableDatas.length;
                    pagination.pageSize = tableDatas.length == 18 ? 6 : tableDatas.length == 15 ? 15 : tableDatas.length;
                }
                else if (twoRow) {
                    pagination.total = (analysisDimension === 'DEPARTMENT') ? totalCount * 2 : (Object.entries(tableDatas || {})).length * 2;
                    pagination.pageSize = 10;
                }
                else if (threeRow) {
                    pagination.total = (analysisDimension === 'DEPARTMENT') ? totalCount * 3 : (Object.entries(tableDatas || {})).length * 3;
                    pagination.pageSize = 9;
                }
                else  {
                    pagination.total = (analysisDimension === 'DEPARTMENT') ? totalCount : (Object.entries(tableDatas || {})).length;
                    pagination.pageSize = 10;
                }
                if(!tableChange){
                    pagination.current=1 
                }
                this.setState({
                    data: res,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getRender = (text, record) => {
        const obj = {
            children: text,
            props: {},
        };
        const { rowSpan } = record;
        if (rowSpan || rowSpan === 0) {
            obj.props.rowSpan = rowSpan;
        }
        return obj;
    }

    getColumns = () => {
        const { data={}, 
        params
    } = this.state;
        //const {params}=this.props;
        const { monthList } = data;
        const { analysisDimension, displayType } = params;
        const columns = [];
        if (analysisDimension === 'PROJECT_AREA') {
            displayType === 'Difference' && 
            columns.push(
                {
                    title: '业务线',
                    dataIndex: 'lineOfBusinessString',
                    index: 'lineOfBusinessString',
                    width: 80,
                    render: this.getRender,
                });
            columns.push({
                title: '项目领域',
                dataIndex: 'projectArea',
                index: 'projectArea',
                width: 150,
                render: this.getRender,
            },{
                title: '统计项',
                dataIndex: 'statistics',
                index: 'statistics',
                width: 140,
            });
        }
        if (analysisDimension === 'DISEASE' || analysisDimension === 'SICKNESS') {
            displayType === 'Difference' && 
            columns.push(
                {
                    title: '业务线',
                    dataIndex: 'lineOfBusinessString',
                    index: 'lineOfBusinessString',
                    width: 80,
                    render: this.getRender,
                });
            columns.push({
                    title: '项目领域',
                    dataIndex: 'projectArea',
                    index: 'projectArea',
                    width: 150,
                    render: this.getRender,
                },
                {
                    title: `${analysisDimension === 'DISEASE' ? '疾病分类': '疾病'}`,
                    dataIndex: `${analysisDimension === 'DISEASE' ? 'diseaseType' : 'diseaseName'}`,
                    index: `${analysisDimension === 'DISEASE' ? 'diseaseType' : 'diseaseName'}`,
                    width: 150,
                    render: this.getRender,
                },
                {
                title: '统计项',
                dataIndex: 'statistics',
                index: 'statistics',
                width: 140,
            });
        }
        if (analysisDimension === 'PROJECT') {
            displayType === 'Difference' && 
            columns.push(
                {
                    title: '业务线',
                    dataIndex: 'lineOfBusinessString',
                    index: 'lineOfBusinessString',
                    width: 80,
                    render: this.getRender,
                });
            columns.push(
                {
                    title: '项目分类',
                    dataIndex: 'projectType',
                    index: 'projectType',
                    width: 150,
                    render: this.getRender,
                },
                {
                title: '统计项',
                dataIndex: 'statistics',
                index: 'statistics',
                width: 140,
            });
        }
        if (analysisDimension === 'GLOBAL') {
            displayType === 'Difference' && 
            columns.push(
                {
                    title: '业务线',
                    dataIndex: 'lineOfBusinessString',
                    index: 'lineOfBusinessString',
                    width: 80,
                    render: this.getRender,
                });
            columns.push({
                title: '统计项',
                dataIndex: 'statistics',
                index: 'statistics',
                width: 140,
            });
        } else if (analysisDimension === 'AREA') {
            columns.push({
                title: '大区',
                dataIndex: 'areaName',
                index: 'areaName',
                width: 120,
                render: this.getRender,
            }, {
                title: '统计项',
                dataIndex: 'statistics',
                index: 'statistics',
                width: 140,
            });
        } else if (analysisDimension === 'CITY') {
            columns.push(
                {
                    title: '大区',
                    dataIndex: 'areaName',
                    index: 'areaName',
                    fixed: 'left',
                    width: 60,
                    render: this.getRender,
                }, {
                title: '省份',
                dataIndex: 'provinceName',
                index: 'provinceName',
                fixed: 'left',
                width: 80,
                render: this.getRender,
            }, {
                title: '城市',
                dataIndex: 'cityName',
                index: 'cityName',
                fixed: 'left',
                width: 80,
                render: this.getRender,
            }, {
                title: '统计项',
                dataIndex: 'statistics',
                index: 'statistics',
                width: 140,
            });
        } else if (analysisDimension === 'HOSPITAL' || analysisDimension === 'DEPARTMENT') {
            columns.push({
                title: '大区',
                dataIndex: 'areaName',
                index: 'areaName',
                fixed: 'left',
                width: 60,
                render: this.getRender,
            }, {
                title: '省份',
                dataIndex: 'provinceName',
                index: 'provinceName',
                fixed: 'left',
                width: 80,
                render: this.getRender,
            }, {
                title: '城市',
                dataIndex: 'cityName',
                index: 'cityName',
                fixed: 'left',
                width: 80,
                render: this.getRender,
            }, {
                title: '医院',
                dataIndex: 'hospitalName',
                index: 'hospitalName',
                fixed: 'left',
                width: 140,
                render: this.getRender,
            }, {
                title: '院区',
                dataIndex: 'courtyardArea',
                index: 'courtyardArea',
                fixed: 'left',
                width: 80,
                render: this.getRender,
            });
            if (analysisDimension === 'DEPARTMENT') {
                columns.push({
                    title: '科室',
                    dataIndex: 'departmentName',
                    index: 'departmentName',
                    fixed: 'left',
                    width: 100,
                    render: this.getRender,
                });
            }
            columns.push({
                title: '统计项',
                dataIndex: 'statistics',
                index: 'statistics',
                fixed: 'left',
                width: 140,
            });
        }

        (monthList || []).forEach(i => {
            const { year, month } = i;
            const title = `${year}.${month}`;
            let width = 60;
            if (analysisDimension === 'HOSPITAL') {
                width = 60;
            }
            columns.push({
                title,
                dataIndex: title,
                index: title,
                width,
            });
        });
        return columns;
    }

    getGlobalData = (dataSource, data, moduleType) => {
        const { tableDatas = [] } = data; //linesData, columnsData, 
        tableDatas.map(item => {
            const params = {
                index: dataSource.length + 1,
                statistics: item.statisticName ? item.statisticName : item.name,
                lineOfBusinessString: item.lineOfBusinessString,
                rowSpan: this.props.displayType === 'ALL' ? 1 : item.rowSpan,
            };
            const { mainData = [] } = item;
            mainData.forEach(i => {
                const { year, month, tableValue } = i;
                params[`${year}.${month}`] = tableValue;
            });
            dataSource.push(params);
        })
    }

    getProjectAreaData = (dataSource, data, moduleType) => {
 
        const statisticsStr = statisticsEnum[moduleType];
        let statisticsArr = [];
        if (statisticsStr) {
            statisticsArr = statisticsStr.indexOf('/') ? statisticsStr.split('/') : [statisticsStr];
        }
        const { tableDatas = [] } = data;
        let idx = 0
        tableDatas.map(item => {
            const { mainData = [], secondData = [], thirdData = [] } = item;
            const params = {
                index: idx++,
                projectArea: item.invAreaName,
                lineOfBusinessString: item.lineOfBusinessString,
                rowSpan: (thirdData && thirdData.length > 0) ? 3 : (secondData && secondData.length) > 0 ? 2 : 1,
            };
            if (mainData && mainData.length) {
                mainData.forEach(i => {
                    const { year, month, dAmount, tableValue } = i;
                    if (moduleType === 'MONTH_STANDARD_VISIT_AMOUNT') {
                        params[`${year}.${month}`] = dAmount;
                    } else {
                        params[`${year}.${month}`] = tableValue;
                    }
                    params.statistics = statisticsArr[0];
                });
                dataSource.push(params);
            }
            if (secondData && secondData.length) {
                const params = {
                    index: idx++,
                    statistics: statisticsArr.length > 1 && statisticsArr[1],
                    rowSpan: 0,
                };
                secondData.forEach(i => {
                    const { year, month, dAmount, tableValue } = i;
                    if (moduleType === 'MONTH_STANDARD_VISIT_AMOUNT') {
                        params[`${year}.${month}`] = dAmount;
                    } else {
                        params[`${year}.${month}`] = tableValue;
                    }
                });
                dataSource.push(params);
            }
            if (thirdData && thirdData.length) {
                const params = {
                    index: idx++,
                    statistics: statisticsArr.length > 2 && statisticsArr[2],
                    rowSpan: 0,
                };
                thirdData.forEach(i => {
                    const { year, month, tableValue } = i;
                    params[`${year}.${month}`] = tableValue;
                });
                dataSource.push(params);
            }
        })
    }

    getDiseaseData = (dataSource, data, moduleType) => {
        // const { tableDatas = [] } = data; //linesData, columnsData, 
        // tableDatas.map(item => {
        //     const params = {
        //         index: dataSource.length + 1,
        //         statistics: item.name,
        //         projectArea:item.invAreaName,
        //         diseaseType:item.diseaseName,
        //     };
        //     const { mainData = [] } = item;
        //     mainData.forEach(i => {
        //         const { year, month, tableValue } = i;
        //         params[`${year}.${month}`] = tableValue;
        //     });
        //     dataSource.push(params);
        // })
        const statisticsStr = statisticsEnum[moduleType];
        let statisticsArr = [];
        if (statisticsStr) {
            statisticsArr = statisticsStr.indexOf('/') ? statisticsStr.split('/') : [statisticsStr];
        }
        const { tableDatas = [] } = data;
        let idx = 0
        tableDatas.map(item => {
            const { mainData = [], secondData = [], thirdData = [] } = item;
            const params = {
                index: idx++,
                projectArea: item.invAreaName,
                diseaseType: item.diseaseClassName,
                diseaseName: item.diseaseName,
                lineOfBusinessString: item.lineOfBusinessString,
                rowSpan: (thirdData && thirdData.length > 0) ? 3 : (secondData && secondData.length) > 0 ? 2 : 1,
            };
            if (mainData && mainData.length) {
                mainData.forEach(i => {
                    const { year, month, dAmount, tableValue } = i;
                    if (moduleType === 'MONTH_STANDARD_VISIT_AMOUNT') {
                        params[`${year}.${month}`] = dAmount;
                    } else {
                        params[`${year}.${month}`] = tableValue;
                    }
                    params.statistics = statisticsArr[0];
                });
                dataSource.push(params);
            }
            if (secondData && secondData.length) {
                const params = {
                    index: idx++,
                    statistics: statisticsArr.length > 1 && statisticsArr[1],
                    rowSpan: 0,
                };
                secondData.forEach(i => {
                    const { year, month, dAmount, tableValue } = i;
                    if (moduleType === 'MONTH_STANDARD_VISIT_AMOUNT') {
                        params[`${year}.${month}`] = dAmount;
                    } else {
                        params[`${year}.${month}`] = tableValue;
                    }
                });
                dataSource.push(params);
            }
            if (thirdData && thirdData.length) {
                const params = {
                    index: idx++,
                    statistics: statisticsArr.length > 2 && statisticsArr[2],
                    rowSpan: 0,
                };
                thirdData.forEach(i => {
                    const { year, month, tableValue } = i;
                    params[`${year}.${month}`] = tableValue;
                });
                dataSource.push(params);
            }
        })

    }
    
    getProjectTypeData = (dataSource, data, moduleType) => {
        // const { tableDatas = [] } = data; //linesData, columnsData, 
        // tableDatas.map(item => {
        //     const params = {
        //         index: dataSource.length + 1,
        //         statistics: item.name,
        //         projectType:item.invTypeName,
        //     };
        //     const { mainData = [] } = item;
        //     mainData.forEach(i => {
        //         const { year, month, tableValue } = i;
        //         params[`${year}.${month}`] = tableValue;
        //     });
        //     dataSource.push(params);
        // })

        const statisticsStr = statisticsEnum[moduleType];
        let statisticsArr = [];
        if (statisticsStr) {
            statisticsArr = statisticsStr.indexOf('/') ? statisticsStr.split('/') : [statisticsStr];
        }
        const { tableDatas = [] } = data;
        let idx = 0
        tableDatas.map(item => {
            const { mainData = [], secondData = [], thirdData = [] } = item;
            const params = {
                index: idx++,
                projectType:item.invTypeName,
                lineOfBusinessString: item.lineOfBusinessString,
                rowSpan: (thirdData && thirdData.length > 0) ? 3 : (secondData && secondData.length) > 0 ? 2 : 1,
            };
            if (mainData && mainData.length) {
                mainData.forEach(i => {
                    const { year, month, dAmount, tableValue } = i;
                    if (moduleType === 'MONTH_STANDARD_VISIT_AMOUNT') {
                        params[`${year}.${month}`] = dAmount;
                    } else {
                        params[`${year}.${month}`] = tableValue;
                    }
                    params.statistics = statisticsArr[0];
                });
                dataSource.push(params);
            }
            if (secondData && secondData.length) {
                const params = {
                    index: idx++,
                    statistics: statisticsArr.length > 1 && statisticsArr[1],
                    rowSpan: 0,
                };
                secondData.forEach(i => {
                    const { year, month, dAmount, tableValue } = i;
                    if (moduleType === 'MONTH_STANDARD_VISIT_AMOUNT') {
                        params[`${year}.${month}`] = dAmount;
                    } else {
                        params[`${year}.${month}`] = tableValue;
                    }
                });
                dataSource.push(params);
            }
            if (thirdData && thirdData.length) {
                const params = {
                    index: idx++,
                    statistics: statisticsArr.length > 2 && statisticsArr[2],
                    rowSpan: 0,
                };
                thirdData.forEach(i => {
                    const { year, month, tableValue } = i;
                    params[`${year}.${month}`] = tableValue;
                });
                dataSource.push(params);
            }
        })
    }

    getAreaData = (dataSource, data, moduleType) => {
        console.log(moduleType);
        const statisticsStr = statisticsEnum[moduleType];
        let statisticsArr = [];
        if (statisticsStr) {
            statisticsArr = statisticsStr.indexOf('/') ? statisticsStr.split('/') : [statisticsStr];
        }
        const { tableDatas = [] } = data;
        let idx = 0
        tableDatas.map(item => {
            const { mainData = [], secondData = [], thirdData = [] } = item;
            const params = {
                index: idx++,
                areaName: item.areaName,
                rowSpan: (thirdData && thirdData.length > 0) ? 3 : (secondData && secondData.length) > 0 ? 2 : 1,
            };
            if (mainData && mainData.length) {
                mainData.forEach(i => {
                    const { year, month, dAmount, tableValue } = i;
                    if (moduleType === 'MONTH_STANDARD_VISIT_AMOUNT') {
                        params[`${year}.${month}`] = dAmount;
                    } else {
                        params[`${year}.${month}`] = tableValue;
                    }
                    params.statistics = statisticsArr[0];
                });
                dataSource.push(params);
            }
            if (secondData && secondData.length) {
                const params = {
                    index: idx++,
                    statistics: statisticsArr.length > 1 && statisticsArr[1],
                    rowSpan: 0,
                };
                secondData.forEach(i => {
                    const { year, month, dAmount, tableValue } = i;
                    if (moduleType === 'MONTH_STANDARD_VISIT_AMOUNT') {
                        params[`${year}.${month}`] = dAmount;
                    } else {
                        params[`${year}.${month}`] = tableValue;
                    }
                });
                dataSource.push(params);
            }
            if (thirdData && thirdData.length) {
                const params = {
                    index: idx++,
                    statistics: statisticsArr.length > 2 && statisticsArr[2],
                    rowSpan: 0,
                };
                thirdData.forEach(i => {
                    const { year, month, tableValue } = i;
                    params[`${year}.${month}`] = tableValue;
                });
                dataSource.push(params);
            }
        })
    }

    // 按城市分析 - table 处理数据
    getCityData = (dataSource, data, moduleType) => { // analysisDimension
        const { cityList } = data || {};
        const datas = cityList;
        this.handleTableData(dataSource, datas, moduleType);
    }

    // 按医院分析/按科室分析 -- table 处理数据
    getHospitalData = (dataSource, data, moduleType) => { // analysisDimension
        const { tableDatas } = data;
        this.handleTableData(dataSource, tableDatas, moduleType);
    }

    // 不同类型的存在取值来源的不同
    getDataFromSource = (data, moduleType) => {
        const { amount, rate, dAmount } = data || {};
        let val = '';
        if (moduleType === 'MONTH_NEW_SITE'
            || moduleType === 'MONTH_CRC_FTE'
            || moduleType === 'MONTH_PER_RANDOM_AMOUNT'
            || moduleType === 'MONTH_PER_VISIT_AMOUNT'
            || moduleType === 'MONTH_PER_STANDARD_VISIT_AMOUNT'
            || moduleType === 'MONTH_UNITS_FTE_GROUP'
            || moduleType === 'MONTH_UNITS_FTE_VISIT'
            || moduleType === 'MONTH_UNITS_FTE_STANDARD_VISIT'
            || moduleType === 'REQUIREMENT_SATISFIED_GLOBAL'
            || moduleType === 'MONITOR_SITE_START_GLOBAL'
            || moduleType === 'REQUIREMENT_FTE_GLOBAL'
            || moduleType === 'MONTH_MAJOR_EVENT_RATE'
            || moduleType === 'PLAN_FTE'
        ) {
            val = rate;
        } else if (moduleType === 'MONTH_STANDARD_VISIT_AMOUNT') {
            val = dAmount;
        } else {
            val = amount;
        }
        return val;
    }

    handleTableData = (dataSource, datas, moduleType) => {
        const statisticsStr = statisticsEnum[moduleType];
        let statisticsArr = [];
        if (statisticsStr) {
            statisticsArr = statisticsStr.indexOf('/') ? statisticsStr.split('/') : [statisticsStr];
        }
        let idx = 0;
        const tablesEntries = Object.entries(datas || {});
        for (const [key, value] of tablesEntries) {
            const {
                mainData = [],
                secondData = [],
                thirdData = [],
                areaName,
                cityName,
                provinceName, // 按医院分析/按科室分析  名称不统一造成
                hospitalName, // 按医院分析/按科室分析  名称不统一造成
                courtyardArea,
                name,  // 按城市分析  名称不统一造成
                province, // 按城市分析  名称不统一造成
                departmentName
            } = value || {};
            const params = {
                index: idx++,
                areaName,
                cityName: cityName || name,
                provinceName: provinceName || province,
                hospitalName,
                courtyardArea,
                departmentName,
                rowSpan: (thirdData && thirdData.length > 0) ? 3 : (secondData && secondData.length) > 0 ? 2 : 1,
            };
            if (mainData && mainData.length) {
                mainData.forEach(i => {
                    const { year, month } = i;
                    params[`${year}.${month}`] = this.getDataFromSource(i, moduleType);
                    params.statistics = statisticsArr[0];
                });
                dataSource.push(params);
            }
            if (secondData && secondData.length) {
                const params = {
                    index: idx++,
                    statistics: statisticsArr.length > 1 && statisticsArr[1],
                    rowSpan: 0,
                };
                secondData.forEach(i => {
                    const { year, month } = i;
                    params[`${year}.${month}`] = this.getDataFromSource(i, moduleType);
                });
                dataSource.push(params);
            }
            if (thirdData && thirdData.length) {
                const params = {
                    index: idx++,
                    statistics: statisticsArr.length > 2 && statisticsArr[2],
                    rowSpan: 0,
                };
                thirdData.forEach(i => {
                    const { year, month } = i;
                    const unit = (moduleType === 'REQUIREMENT_SATISFIED_GLOBAL' || moduleType === "MONTH_MAJOR_EVENT_RATE") ? '%' : '';
                    params[`${year}.${month}`] = this.getDataFromSource(i, moduleType) + unit;
                });
                dataSource.push(params);
            }
        }
    }

    getDataSource = () => {
        const { data, 
            params
         } = this.state;
         //const {params}=this.props;
        const { moduleType, analysisDimension } = params;
        const dataSource = [];
        if (analysisDimension === 'GLOBAL') {
            this.getGlobalData(dataSource, data, moduleType);
        } else if (analysisDimension === 'AREA') {
            this.getAreaData(dataSource, data, moduleType);
        } else if (analysisDimension === 'CITY') {
            this.getCityData(dataSource, data, moduleType);
        } else if (analysisDimension === 'HOSPITAL' || analysisDimension === 'DEPARTMENT') {
            this.getHospitalData(dataSource, data, moduleType);
        } else if (analysisDimension === 'PROJECT_AREA') {
            this.getProjectAreaData(dataSource, data, moduleType);
        } else if (analysisDimension === 'DISEASE' || analysisDimension === 'SICKNESS'){
            this.getDiseaseData(dataSource, data, moduleType);
        } else if (analysisDimension === 'PROJECT'){
            this.getProjectTypeData(dataSource, data, moduleType); 
        }
        return { dataSource };
    }

    handleTableChange = ({ pagination }) => {
        const { params } = this.state;
        const { analysisDimension } = params;
        // let tableChange =true;
        // this.setState({ pagination }, () => {
        //     if (analysisDimension === 'HOSPITAL' || analysisDimension === 'DEPARTMENT' || analysisDimension === 'CITY'){
        //     this.loadData(tableChange);
        //     }
        // });

        this.setState({ pagination: {...pagination} },()=>{
            if(analysisDimension == 'GLOBAL' ||  analysisDimension == 'DEPARTMENT'){
                this.loadData(true);
            }
        });
    }

    render() {
        const { loading, pagination } = this.state;
        const { dataSource } = this.getDataSource() || {};
        return (
            <TableC
                columns={this.getColumns()}
                data={dataSource}
                rowKey="index"
                loading={loading}
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

export default ProjectTable;


// WEBPACK FOOTER //
// ./src/components/homePage/DimensionAnalysis/components/ProjectTable.js